import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngSelect } from '../../inputs';

@Component({
  selector: 'ing-select-child',
  templateUrl: './select-child.component.html',
  styleUrls: ['./select-child.component.scss']
})
export class SelectChildComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() inputParent: IngSelect;
  @Input() inputChild: IngSelect;

  selectedValueParent;
  selectedValueChild;

  constructor() { }

  ngOnInit() {
    this.selectedValueParent = this.inputParent.options.filter(op => { return op.id == this.inputParent.value });

    if(!!this.selectedValueParent && this.selectedValueParent.length > 0) {
      this.selectedParent(this.selectedValueParent[0]);

      // setTimeout(() => {
        this.selectedValueChild = this.inputChild.options.filter(op => { return op.id == this.inputChild.value });
      // });
    }
  }

  selectedParent($event) {
    this.form.controls[this.inputParent.key].setValue($event.id);

    let opciones: any = this.inputParent.options.find(o => { return o.id == $event.id });

    this.inputChild.options = opciones.child;
  }

  selectedChild($event) {
    this.form.controls[this.inputChild.key].setValue($event.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/select-child/select-child.component.ts